import styled from '@emotion/styled';
import { ComboboxOption } from '@headlessui/react';

import { CocoSharpText } from '../../../CocoSharpText/CocoSharpText';

export const Group = styled(CocoSharpText)`
  display: flex;
  gap: var(--spacing-8);
  align-items: center;
  color: var(--color-secondary-40);
  padding: var(--spacing-20) var(--spacing-16) var(--spacing-12)
    var(--spacing-16);

  svg {
    height: var(--spacing-20);
    width: var(--spacing-20);
  }
`;

export const Option = styled(ComboboxOption)`
  padding: var(--spacing-8) var(--spacing-8) var(--spacing-8) var(--spacing-44);
  cursor: pointer;

  &:hover,
  &[data-focus] {
    background: var(--color-secondary-95);
  }
`;

export const Suggestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLabel = styled(CocoSharpText)`
  max-width: 90%;
`;
